import { ComponentProps } from 'react';
import { LinkCard } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { enrichURI } from '../../../utils/links';
import { JobTbdCardProps } from './JobTbdCard.types';

export const getAdditionalActionProps = (clickAction: JobTbdCardProps['jobData']['clickAction'], pageCtxId: string) => {
    let additionalActionProps: Partial<ComponentProps<typeof Button | typeof LinkCard>> = {};

    switch (clickAction.type) {
        case 'link':
            additionalActionProps = {
                href: enrichURI(clickAction.href, { source: 'tailored_homepage', ref_ctx_id: pageCtxId }),
            };
            break;
        case 'drawer':
            additionalActionProps = {
                as: 'div',
            };
            break;
        default:
            break;
    }

    return additionalActionProps;
};
